import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link, useHistory } from 'react-router-dom';

import OnboardingShell, { useOnboardingStyles } from '../OnboardingShell';
import GenericState from '../../../MyComponents/GenericLoadingErrorState/GenericState';
import userApi from '../../../Api/userApi';
import store from '../../../redux/store';
import { updateUserSubscription } from '../../../redux/actions';
import { PROFILE_LINK, SUBSCRIPTIONS_LINK } from '../../../common/urlLinks';
import { TRIAL_DAYS } from '../../../shared/Capabilities';
import { GA_EVENT_TREE } from '../../../gaConstants';
import { cx } from '../../Home/HomeDashboard/dashboardStyles';

/** Starts the free Premium trial, or explains it has already been used. */
const TrialStage = ({ profile }) => {
    const classes = useOnboardingStyles();
    const intl = useIntl();
    const history = useHistory();
    const [starting, setStarting] = useState(false);

    const startTrial = () => {
        setStarting(true);
        userApi
            .startTrial()
            .then((res) => {
                window.logAppActivity(GA_EVENT_TREE.mainPage.onboarding.startTrial);
                store.dispatch(updateUserSubscription(res.data.subscription));
                history.push(PROFILE_LINK);
            })
            .catch(() => setStarting(false));
    };

    if (profile?.subscription?.trialStarted === true) {
        return (
            <OnboardingShell
                title={<FormattedMessage id="redesign.onboarding.trialDone.title" />}
                lead={<FormattedMessage id="onboarding.start.trialAlreadyDone" />}
            >
                <div className={classes.actions} style={{ marginTop: 0 }}>
                    <Link to={SUBSCRIPTIONS_LINK} className={classes.primary}>
                        <FormattedMessage id="redesign.cta.plans" />
                        <span aria-hidden="true">→</span>
                    </Link>
                </div>
            </OnboardingShell>
        );
    }

    return (
        <OnboardingShell
            title={<FormattedMessage id="subscriptions.subscription.TRIAL.name" />}
            lead={<FormattedMessage id="onboarding.start.startTrialDescription" />}
        >
            <div className={cx(classes.card, classes.centered)}>
                {starting ? (
                    <GenericState isLoading={true} inline={true} />
                ) : (
                    <button type="button" onClick={startTrial} className={classes.primary}>
                        <FormattedMessage id="subscriptions.subscription.startTrial" values={{ days: TRIAL_DAYS }} />
                        <span aria-hidden="true">→</span>
                    </button>
                )}
                <p className={classes.trust}>
                    {intl.formatMessage({ id: 'redesign.pricing.hero.trust.noCard' })}
                    {' · '}
                    {intl.formatMessage({ id: 'redesign.pricing.hero.trust.cancel' })}
                </p>
            </div>
        </OnboardingShell>
    );
};

export default TrialStage;
